let moduleName = 'firebaseFactory';

class FirebaseFactory {

    constructor(CONFIG, $firebaseAuth, $cookies){
        //Setting variables
        // Initialize Firebase

        this.const = CONFIG;
        this.auth = $firebaseAuth();
        this.cookies = $cookies;
    }

    /***
     * Check if user is logged or not
     * @returns {boolean}
     */
    isLogged (user = this.auth) {
        return !!user && !!user.uid;
    }

    /***
     * Create new user
     * @param postData
     * @returns {!firebase.Promise.<void>}
     */
    createUserWithEmailAndPassword (email, password) {
        return this.auth.$createUserWithEmailAndPassword(email, password);
    }

    updatePassword(newPassword) {
        return this.auth.$updatePassword(newPassword);
    }

    /***
     * Send password reset
     * @param email
     * @returns {*}
     */
    sendPasswordResetEmail (email) {
        return this.auth.$sendPasswordResetEmail(email, 'http://www.google.it');
    }

    /***
     * Sign in
     * @param email
     * @param password
     * @returns {*}
     */
    signInWithEmailAndPassword (email, password) {
        return this.auth.$signInWithEmailAndPassword(email, password);
            /*.then((response) => {
                console.log(response);
            })
            .catch((error) => {
                // Handle Errors here.
                let errorCode = error.code;
                let errorMessage = error.message;
                // ...
            });*/
    }

    /***
     * Delete the current user
     * @returns {*}
     */
    deleteUser () {
        return this.auth.$deleteUser();
            /*.then(() => {
            $scope.message = "User deleted";
        }).catch(function(error) {
            $scope.error = error;
        });*/
    }

    /***
     * Log out
     */
    logout () {
        this.cookies.remove('region');
        this.cookies.remove('token');
        this.cookies.remove('accessToken');
        this.cookies.remove('logged_user');
        localStorage.removeItem('logged_user');

        this.auth.$signOut();
    }

    /***
     * Save user into real time db
     * @param user
     */
    saveUser (user) {
        firebase.database().ref(`users/${user.uid}`).set({
            "isAdmin": user.isAdmin,
            "permissions": user.permissions,
            "displayName": user.displayName
        });
    }

    /***
     * Get Users
     * @returns {!firebase.Promise.<*>}
     */
    getUsers () {
        return firebase.database().ref('users');
        /*firebase.database().ref('users').once('value').then((snapshot) => {
            console.log(snapshot.val());
        });*/
    }

    /***
     * Get Once Users
     * @returns {!firebase.Promise.<*>}
     */
    getOnceUsers () {
        return firebase.database().ref('users').once('value');
    }


    getOnceUser (uid) {
        return firebase.database().ref('users/' + uid).once('value');
    }

    /***
     * Get User detail
     * @param uid
     * @returns {!firebase.database.Reference}
     */
    getUser (uid) {
        return firebase.database().ref('users/' + uid);
    }

    /***
     * Update user
     * @param user
     * @param displayName
     * @param photoURL
     * @returns {!firebase.Promise.<void>|*|{name, j}}
     */
    updateUser (user, displayName = null, photoURL = null) {
        return user.updateProfile({
            displayName: !!displayName ? displayName : '',
            photoURL: !!photoURL ? photoURL : ''
        });
    }

    /***
     * Remove User
     * @param key
     */
    removeUser (key) {
        let usersRef = firebase.database().ref('users').child(key);
        usersRef.on('child_added', (user) => {
            user.ref.remove();
        });
    }

    /***
     * Get Id Token
     * @returns {firebase.Promise.<string>}
     */
    getIdToken () {
        console.log('currentUser', firebase.auth().currentUser);
        return firebase.auth().currentUser ? firebase.auth().currentUser.getIdToken() : null;
    }


    /***
     * Get Poll
     * @param uid
     * @returns {firebase.database.Reference}
     */
    getPoll(uid) {
        return firebase.database().ref('survey_results/' + uid).once('value');
    }

    /**
     * FirebaseFactory
     * @param CONFIG
     * @returns {FirebaseFactory}
     */
    static firebaseFactory(CONFIG, $firebaseAuth, $cookies){
        return new FirebaseFactory(CONFIG, $firebaseAuth, $cookies);
    }
}

FirebaseFactory.firebaseFactory.$inject = ['CONFIG', '$firebaseAuth', '$cookies'];

angular.module(moduleName, [])
    .factory('FirebaseFactory', FirebaseFactory.firebaseFactory);

export default moduleName;



// WEBPACK FOOTER //
// ./src/app/services/firebaseFactory.js